module.exports = __webpack_public_path__ + "static/media/bay.e7dae47e.svg";